import styled from 'styled-components/macro';

import { lowHeightScreens, mediumScreens, smallScreens } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';
import { AlertTitle } from 'components/tools/alerts/Alerts.styles';

const sidePadding = '40px';
const reducedSidePadding = '35px';

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
`;

export const Section = styled.div`
  background-color: ${colors.baseBackground};
`;

export const BlockingAlertHeader = styled.div`
  padding: 23px ${sidePadding};
  border-bottom: 1px solid ${colors.lightGray6};

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 20px ${reducedSidePadding};
  }
`;

export const BlockingAlertContainer = styled.div`
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const BlockingAlertContentContainer = styled.div`
  font-size: 12px;
  padding: 23px ${sidePadding} 40px;

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 20px ${reducedSidePadding};
    font-size: 9px;
  }
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }
`;

export const BlockingAlertContent = styled.div`
  color: ${colors.lightBlack};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonSection = styled.div`
  text-align: center;
  margin: 30px 0px 10px;

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 19px;
    letter-spacing: 0.1px;
    color: ${colors.darkGray1};
  }
`;

export const BlockingAlertNote = styled(AlertTitle)`
  color: ${colors.red};
`;
